import { strRegistrationApiSender } from 'utils/str-registration-api-sender';

export interface PaymentBody {
  paymentId: string | number;
  signatory: string;
  email: string;
  token?: string;
}

export const payCC = (body: PaymentBody) => strRegistrationApiSender.post('/payCC', body);

export const payACH = (body: PaymentBody) => strRegistrationApiSender.post('/payACH', body);

export const payACHDirectDebit = (body: PaymentBody) => strRegistrationApiSender.post('/payACHDirectDebit', body);

export const payCheck = (body: PaymentBody) => strRegistrationApiSender.post('/payCheck', body);

export const payGeneric = (body: PaymentBody) => strRegistrationApiSender.post('/payGeneric', body);

export const payACHCredit = (body: PaymentBody) => strRegistrationApiSender.post('/payACHCredit', body);

export const getStripePublicKey = () => strRegistrationApiSender.get('/stripe-public', undefined);

// place is a static field shared across every StrRegistrationAPISender instance, so
// setting it on the shared singleton here is equivalent to the "fresh instance" pattern
// these two callers used previously.
export const cardConnectPostback = (place: string, body: unknown) => {
  strRegistrationApiSender.setCurrentPlace(place);
  return strRegistrationApiSender.post('/cardConnectPostback', body, 'json');
};

export const cyberSourceInitiatePayment = (place: string, body: unknown) => {
  strRegistrationApiSender.setCurrentPlace(place);
  return strRegistrationApiSender.post('/cyberSourceInitiatePayment', body, 'json');
};

export const checkRenewalPayment = (paymentId: string | number) =>
  strRegistrationApiSender.get(`/checkRenewalPayment/${paymentId}`, undefined);

export const checkTotPayment = (paymentId: string | number) =>
  strRegistrationApiSender.get(`/checkTotPayment/${paymentId}`, undefined);
